import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type OrdersSettingsState = {
    customHourOffset: string;
};

const initialState: OrdersSettingsState = {
    customHourOffset: "0",
};

export const ordersSettingsSlice = createSlice({
    name: "ordersSettings",
    initialState,
    reducers: {
        setCustomHourOffset: (state, action: PayloadAction<string>) => {
            state.customHourOffset = action.payload;
        },
    },
});

export const { setCustomHourOffset } = ordersSettingsSlice.actions;

export const selectCustomHourOffset = (state: { ordersSettings: OrdersSettingsState }) => 
    state.ordersSettings.customHourOffset; 